import { render } from "./CopyFieldButton.vue?vue&type=template&id=97df9046&ts=true"
import script from "./CopyFieldButton.vue?vue&type=script&lang=ts"
export * from "./CopyFieldButton.vue?vue&type=script&lang=ts"

import "./CopyFieldButton.vue?vue&type=style&index=0&id=97df9046&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__